export const interlaceColorFromGreenToRed = (percentagePoint) => 
{
    const r= Math.round(255*Math.min(1,2.0 * (1 - percentagePoint)))
    const g= Math.round(255*Math.max(0,2.0 * (percentagePoint)))
    const b= 0
    const interlacedColor = "rgb("+r + ","+ g+","+b+")";
    return interlacedColor;
}